import { render } from "./SIPChannelModalImport.vue?vue&type=template&id=bf9d8da2"
import script from "./SIPChannelModalImport.vue?vue&type=script&lang=js"
export * from "./SIPChannelModalImport.vue?vue&type=script&lang=js"

import "./SIPChannelModalImport.vue?vue&type=style&index=0&id=bf9d8da2&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__